import { useEffect, useRef } from "react";
import ZOOMIN from "../../../assets/zoom-in.svg";
import ZOOMOUT from "../../../assets/zoom-out.svg";

const ZOOM_MIN = 200;
const ZOOM_MAX = 2000;
const ZOOM_STEP = 100;
const ZOOM_DEFAULT = 600;

function ImageBox({ imagesArray, currentPage, imageProperty, setImageProperty }) {
  const canvasRef = useRef(null);
  const src =
    Array.isArray(imagesArray) && imagesArray.length > 0
      ? imagesArray[
          Math.max(0, Math.min(currentPage - 1, imagesArray.length - 1))
        ]
      : null;

  const handleZoom = (delta) => {
    if (!setImageProperty) return;
    setImageProperty((prev) => {
      const nextWidth = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, prev.width + delta));
      if (nextWidth === prev.width) return prev;
      return { ...prev, width: nextWidth };
    });
  };

  const handleResetZoom = () => {
    if (!setImageProperty) return;
    setImageProperty((prev) => ({ ...prev, width: ZOOM_DEFAULT }));
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas || !setImageProperty) return;

    const onWheel = (event) => {
      if (!event.ctrlKey && !event.metaKey) return;
      event.preventDefault();
      const delta = event.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP;
      setImageProperty((prev) => {
        const nextWidth = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, prev.width + delta));
        if (nextWidth === prev.width) return prev;
        return { ...prev, width: nextWidth };
      });
    };

    canvas.addEventListener("wheel", onWheel, { passive: false });
    return () => canvas.removeEventListener("wheel", onWheel);
  }, [setImageProperty]);

  if (!src) {
    return (
      <div
        className="document-preview-empty"
        style={{ padding: "1rem", textAlign: "center" }}
      >
        <p style={{ margin: 0, color: "#666" }}>Loading document preview…</p>
      </div>
    );
  }

  const zoomPercent = Math.round(((imageProperty?.width || ZOOM_DEFAULT) / ZOOM_DEFAULT) * 100);
  const currentWidth = imageProperty?.width || ZOOM_DEFAULT;

  return (
    <div className="pdf-viewer">
      <div className="pdf-viewer-canvas" ref={canvasRef}>
        <img
          src={src}
          alt="Claim document page"
          draggable={false}
          style={{
            userSelect: "none",
            width: currentWidth,
            transform: `rotate(${imageProperty?.angle || 0}deg)`,
          }}
        />
      </div>
      {setImageProperty && (
        <div className="reco-zoom-controls">
          <button
            type="button"
            className="reco-zoom-btn"
            disabled={currentWidth <= ZOOM_MIN}
            onClick={() => handleZoom(-ZOOM_STEP)}
            title="Zoom out"
          >
            <img src={ZOOMOUT} alt="Zoom out" />
          </button>
          <button
            type="button"
            className="reco-zoom-level"
            onClick={handleResetZoom}
            title="Reset zoom"
          >
            {zoomPercent}%
          </button>
          <button
            type="button"
            className="reco-zoom-btn"
            disabled={currentWidth >= ZOOM_MAX}
            onClick={() => handleZoom(ZOOM_STEP)}
            title="Zoom in"
          >
            <img src={ZOOMIN} alt="Zoom in" />
          </button>
        </div>
      )}
    </div>
  );
}

export default ImageBox;
